import { useEffect, useState } from 'react';
import SelectLocation from './SelectLocation';
import classes from './booking-link.module.scss';
import { VerifiedBusinessBadgeQuery } from '../../redux/actions/verifiedBusinessBadge/verifiedBusinessBadge';
import { useDispatch, useSelector } from 'react-redux';
import { getPaylaterStatus } from '../../redux/actions/pay-later/payLaterAction';
import moment from 'moment';
import { useParams } from 'react-router';
import SidebarSummary from './sidebar-summary/SidebarSummary';
import Payl8rPopup from './payl8r-popup/Payl8rPopup';
import axios from 'axios';
import SelectTreatment from './SelectTreatment';
import {
    BOOKING_LINK_STEP,
    DISCOUNT_CODE_SUCCESS_MSG,
    DISCOUNT_NOT_APPLICABLE_MSG,
} from './constants';
import SelectDateTime from './SelectDateTime';
import classNames from 'classnames';
import { Toaster } from 'react-hot-toast';
import SelectTeamMember from './SelectTeamMember';
import EnterClientDetails from './EnterClientDetails';
import StepButton from '../../common/StepButton';
import PoweredByFaces from './PoweredByFaces';
import CustomContainer from '../../common/wrapper/Container';
import React from 'react';
import { CreateTreatmentBooking } from '../../redux/actions/treatmentBooking/createTreatmentBooking';
import { GetSprintBookingLinkDetailsAction } from '../../redux/actions/treatmentBooking/getSprintBookingLinkDetails';
import { toastV2 } from '../../common/CustomToast/toastV2';
import { CLEAR_DISCOUNT_CODE_CONST } from '../../redux/constants/discount/discount';
import { CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA } from '../../redux/constants/treatmentBooking/getSprintBookingLinkDetails';
import FlexBetweenItem from '../../common/layout/FlexBetweenItem';
import { AppText } from '../../common/typography/app-text';
import { APP_COMPONENT_SIZE } from '../../../utils/constants';
import { pounds } from '../../../utils/general';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import { BusinessClinicList } from '../../redux/actions/locationList/getBusinessClinicList';
import { GetNoAppointmentAVailableAction } from '../../redux/actions/checkNoAppointmentAvailable/CheckNoAppointmentAvailable';
import { CLEAR_TREATMENT_DETAILS } from '../../redux/constants/treatment-list-const/TreatmentListConst';
import { webBaseUrl } from '../../../config';
import {VALIDATION_REGEX} from "../../../utils/common-regex"

const UPDATE_DISC_TYPE = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
};

function isValidEmail(email) {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailPattern.test(email);
}

function BookingLink() {
    const { slug } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [step, setStep] = useState(BOOKING_LINK_STEP.TREATMENT);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedTreatments, setSelectedTreatments] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [clinicId, setClinicId] = useState(null);
    const [showSelectedDate, setShowSelectedDate] = useState(null);
    const [formatedDate, setFormatedDate] = useState(null);
    const [showSelectedTime, setShowSelectedTime] = useState(null);
    
    const [selectedTreatment, setSelectedTreatment] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const dispatch = useDispatch();

    const [payl8rData, setPayl8rData] = useState(null);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState('');
    const [bookingId, setBookingId] = useState(null);

    // const { businessClinicList } = useSelector((state) => state?.businessLocationListReducer);
    const { discountDetails } = useSelector((state) => state?.discountReducer);
    const { sprintBookingDetails } = useSelector(
        (state) => state?.getSprintBookingLinkDetailsReducer
    );

    const [yourDetails, setYourDetails] = useState({
        clientFName: '',
        clientLName: '',
        clientEmail: '',
    });
    const [validationErrors, setValidationErrors] = useState({
        clientFName: '',
        clientLName: '',
        clientEmail: '',
    });
    const [paymentOptionError, setPaymentOptionError] = useState(null);
    const [shallCreateNewBooking, setShallCreateNewBooking] = useState(true); // if this is true the we will call create booking api
    useEffect(() => {
        if (slug) {
            dispatch(
                getPaylaterStatus({
                    user_id: slug,
                })
            );
        }
    }, [slug]);    

 
    
    // const handlePageLoad = () => {
    //     alert('Welcome! Be careful, you may lose data if you leave.');
    // };

    const [discountValue, setDiscountValue] = useState(0);

    const [selectedTreatmentId, setSelectedTreatmentId] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const { initVerifiedBusinessBadge } = VerifiedBusinessBadgeQuery();
    const { initiateCreateTreatmentBooking, createTreatmentBookingMutationData } =
        CreateTreatmentBooking();
    const { initGetSprintBookingLinkDetails, getSprintBookingLinkDetailsQueryData } =
        GetSprintBookingLinkDetailsAction();

    const getTotalPrice = () => {
        if (selectedTreatment?.length === 0) {
            return 0;
        }
        return selectedTreatment?.reduce((total, item) => total + (item?.amount || 0), 0);
    };
    const getTotalDeposit = () => {
        if (selectedTreatment?.length === 0) {
            return 0;
        }
        return selectedTreatment?.reduce((total, item) => total + (item?.deposit || 0), 0);
    };

    const getTotalPriceAfterDiscount = () => {
        return getTotalPrice() - discountValue;
    };

    useEffect(() => {
        if (discountDetails == null) {
            setDiscountValue(0);
        } else {
            if (discountDetails?.discount_type === 'percentage') {
                setDiscountValue((getTotalPrice() * discountDetails?.discount_unit) / 100);
            } else {
                setDiscountValue(discountDetails?.discount_unit);
            }
        }
    }, [discountDetails]);


    // condition when next step is disabled
    const isNextStepDisabled = () => {
        if (step === BOOKING_LINK_STEP.TREATMENT && selectedTreatment.length === 0) {
            return true;
        }
        if (step === BOOKING_LINK_STEP.DATE_AND_TIME && (!showSelectedDate || !showSelectedTime)) {
            return true;
        }
        if (step === BOOKING_LINK_STEP.TEAM_MEMBER && !selectedTeamMember) {
            return true;
        }
        if (
            step === BOOKING_LINK_STEP.CLIENT_DETAILS &&
            (!yourDetails.clientFName || !yourDetails.clientLName || !yourDetails.clientEmail)
        ) {
            return true;
        }

        return false;
    };

    const initConfirmBookingRequest = (paymentOption, updateDiscountType = false) => {
        let payload = {
            clinicId: parseInt(clinicId),
            date: moment(showSelectedDate, 'dddd, Do MMMM YYYY').format('YYYY-MM-DD'),
            time: moment(showSelectedTime, 'hh:mm A').format('HH:mm:ss'),
            clientEmail: yourDetails?.clientEmail,
            clientFname: yourDetails?.clientFName,
            clientLname: yourDetails?.clientLName,
            treatmentIds: selectedTreatmentId,
            practitionerId: selectedTeamMember?.id,
            payFull: paymentOption === 'Pay in full' ? true : false,
            couponCode: discountDetails?.discount_name ? discountDetails?.discount_name : '',
            createdFrom: businessClinicList?.clinic_DB_id ? 'clinic-detail' : 'na',
        };

        // if we need to update discount add appointment id in payload
        if (updateDiscountType && bookingId) {
            payload.appointmentId = bookingId;

            if (updateDiscountType === UPDATE_DISC_TYPE.REMOVE) {
                payload.couponCode = '';
                payload.removeDiscountCode = 1;
            }
        }

        // else if bookingId is present then we will only update client details
        else if (bookingId) {
            payload = {
                clientEmail: yourDetails?.clientEmail,
                clientFname: yourDetails?.clientFName,
                clientLname: yourDetails?.clientLName,
                appointmentId: bookingId,

                // following fields are required for API sake
                clinicId: parseInt(clinicId),
                date: moment(showSelectedDate, 'dddd, Do MMMM YYYY').format('YYYY-MM-DD'),
                time: moment(showSelectedTime, 'hh:mm A').format('HH:mm:ss'),
            };
        }
        initiateCreateTreatmentBooking(
            payload,
            (res) => {
                setBookingId(res?.data?.booking_id);

                initGetSprintBookingLinkDetails({ bookingId: res.data.booking_id });
            },
            (err) => {
                console.log('err: ', err.message);
                toastV2(err.message);
            }
        );
    };

    // handle discount logic after api call
    useEffect(() => {
        if (discountDetails == null) {
            setDiscountValue(0);
        } else {
            let calculatedDisc = 0;
            if (discountDetails?.discount_type === 'percentage') {
                calculatedDisc = (getTotalPrice() * discountDetails?.discount_unit) / 100;
            } else {
                calculatedDisc = discountDetails?.discount_unit;
            }

            // if pay deposit option selected, then discounted total can not be less than deposit
            if (
                selectedPaymentOption === 'Split payment' &&
                getTotalPrice() - calculatedDisc < getTotalDeposit()
            ) {
                toastV2(DISCOUNT_NOT_APPLICABLE_MSG);
                dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
                return;
            }

            // if monthly payments option selected, then discounted total can not be less than 50
            if (
                selectedPaymentOption === 'Monthly payments' &&
                getTotalPrice() - calculatedDisc < 50
            ) {
                toastV2(DISCOUNT_NOT_APPLICABLE_MSG);
                dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
                return;
            }

            // for any other payment option, grand total can not be less than 0
            if (getTotalPrice() - calculatedDisc < 0) {
                toastV2(DISCOUNT_NOT_APPLICABLE_MSG);
                dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
                return;
            }

            toastV2(DISCOUNT_CODE_SUCCESS_MSG);
            setDiscountValue(calculatedDisc);
            initConfirmBookingRequest(selectedPaymentOption, UPDATE_DISC_TYPE.ADD);
        }
    }, [discountDetails]);

    const handlePaymentOptionChange = (option) => {
        // Validate first name, last name, and email
        const validationErrors = {};
        if (!yourDetails?.clientFName) {
            validationErrors.clientFName = 'Please enter first name!';
        }else if(!VALIDATION_REGEX.validName?.test(yourDetails?.clientFName)){
            validationErrors.clientFName="Please enter valid first name!"
        }
        if (!yourDetails?.clientLName) {
            validationErrors.clientLName = 'Please enter last name!';
        }else if(!VALIDATION_REGEX.validName?.test(yourDetails?.clientLName)){
            validationErrors.clientLName="Please enter valid last name!"
        }
        if (!yourDetails?.clientEmail || !isValidEmail(yourDetails?.clientEmail)) {
            validationErrors.clientEmail = 'Please enter valid email address!';
        }

        setValidationErrors(validationErrors);

        // If there are validation errors, don't proceed with booking
        if (Object.values(validationErrors).some((error) => error)) {
            return;
        }

        if (shallCreateNewBooking) {
            initConfirmBookingRequest(option);
            setShallCreateNewBooking(false);
        }
        setSelectedPaymentOption(option);
    };

    const handleNextStep = () => {
        if (isNextStepDisabled()) {
            return;
        }

        setStep((prev) => prev + 1);
    };

    const getTimeRange = () => {
        if (showSelectedTime) {
            const totalMin = selectedTreatment?.reduce((mins, item) => {
                return mins + (item?.duration || 0);
            }, 0);
            let endTime = moment(`${showSelectedTime}`, 'HH:mm')
                .add(totalMin, 'minutes')
                .format('HH:mm');
            let resultTime = showSelectedTime + ' - ' + endTime;
            return resultTime;
        } else {
            return null;
        }
    };

    const callPayl8rApi = () => {
        var depositeRate = 0.1;
        var interestRate = 0.01;
        // var amount = selectedTreatment?.reduce((total, item) => {
        //     return total + (item?.amount || 0); // Add the amount of each item to the total
        // }, 0);
        // if (amount === 0) {
        //     amount = 100;
        // }
        const amount = getTotalPriceAfterDiscount();
        var username = process.env.REACT_APP_PAYL8R_USERNAME;
        var url = `https://payl8r.com/get-product-page-calculator/1?username=${username}&total=${amount}&depositRate=${depositeRate}&interestRate=${interestRate}`;
        axios.get(url).then((res) => {
            if (res.data.data) {
                var obj = {
                    '3Month': res.data.data[3],
                    '6Month': res.data.data[6],
                    '9Month': res.data.data[9],
                    '12Month': res.data.data[12],
                    amount: amount,
                };
                setPayl8rData(obj);
            }
        });
    };

    useEffect(() => {
        if (slug) {
            initVerifiedBusinessBadge({
                userToken: slug,
            });
        }
    }, [slug]);

    const shallDisplaySidebar = () => {
        return step !== BOOKING_LINK_STEP.LOCATION;
    };
    const shallRenderNextStepButton = () => {
        return step !== BOOKING_LINK_STEP.LOCATION && step !== BOOKING_LINK_STEP.CLIENT_DETAILS;
    };

    const shallRenderMobileStickyFooter = () => {
        if (step === BOOKING_LINK_STEP.TREATMENT) {
            return selectedTreatment?.length > 0;
        }

        if (step === BOOKING_LINK_STEP.DATE_AND_TIME) {
            return showSelectedDate && showSelectedTime;
        }

        return true;
    };

    const shallRenderStickyFooterTreatment = () => {
        if (step === BOOKING_LINK_STEP.TREATMENT) {
            return (
                selectedTreatment?.length > 0 &&
                shallRenderMobileStickyFooter() &&
                shallRenderNextStepButton()
            );
        }
        return false;
    };

    const isNextButtonLoading = () => {
        return createTreatmentBookingMutationData.loading;
    };

    const resetDataAfterTreatmentSelection = () => {
        setShowSelectedDate(null);
        setShowSelectedTime(null);
        setFormatedDate(null);
        setBookingId(null);
        setShallCreateNewBooking(true);
        dispatch({ type: CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA });
        setSelectedPaymentOption('');
        dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
    };

    const resetDataAfterDateOrTimeSelection = () => {
        setBookingId(null);
        setShallCreateNewBooking(true);
        dispatch({ type: CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA });
        setSelectedPaymentOption('');
    };

    const handleRemoveDiscount = () => {
        setDiscountValue(0);
        dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
        // initConfirmBookingRequest(selectedPaymentOption, UPDATE_DISC_TYPE.REMOVE);
    };

    // const { slug } = useParams();
    // const dispatch = useDispatch();
    // const [searchParams, setSearchParams] = useSearchParams();
    const { initBusinessClinicList, businessClinicListQueryData } = BusinessClinicList();
    const { checkNoAppointMentAvailableData, initCheckNoAppointmentAvailable } =
        GetNoAppointmentAVailableAction();

    const { businessClinicList } = useSelector((state) => state?.businessLocationListReducer);
    const clinicListData = useSelector(
        (state) => state?.businessLocationListReducer?.businessClinicList?.items
    );
    const totalClinics = useSelector((state) => state?.businessLocationListReducer?.totalClinics);
    const loadedClinicsCount = useSelector(
        (state) => state?.businessLocationListReducer?.loadedClinicsCount
    );
    const clinicListPage = useSelector(
        (state) => state?.businessLocationListReducer?.clinicListPage
    );

    const isAppointmentDataAvailable =
        checkNoAppointMentAvailableData?.data?.checkNoAppointmentAvailable?.success;

    useEffect(() => {
        initCheckNoAppointmentAvailable({
            tokenSlug: slug,
        });
    }, [slug]);

    const initiateBusinessClinicListApiCall = (refreshList = false) => {
        const clinicSlug = searchParams.get('clinicSlug');
        let newPage = clinicListPage + 1;
        if (refreshList) {
            newPage = 1;
        } else if (totalClinics <= loadedClinicsCount) {
            return;
        }

        initBusinessClinicList({
            userToken: slug,
            includeClinicSlug: clinicSlug,
            page: newPage,
            limit: 15,
        });
    };

    useEffect(() => {
        if (businessClinicList == null) {
            initiateBusinessClinicListApiCall(true);
        }
    }, []);

    useEffect(() => {
        if (searchParams.get('clinicSlug')) {
            clinicListData?.forEach((item, index) => {
                console.log('item: ', item,  item.clinic_slug === searchParams.get('clinicSlug'));
                const selectedClinic = clinicListData?.find((item) => item.clinic_slug === searchParams.get('clinicSlug'));
                console.log('selectedClinic:', selectedClinic);
                if (item.clinic_slug === searchParams.get('clinicSlug')) {
                    setSelectedLocation(item);
                    setClinicId(item.clinic_id);
                    dispatch({ type: CLEAR_TREATMENT_DETAILS });
                    searchParams.delete('clinic_id');
                    setSearchParams(searchParams);
                    setStep(BOOKING_LINK_STEP.TREATMENT);
                }else if(searchParams.get('clinicSlug') && !selectedClinic){
                    window.location.href = `${webBaseUrl}/bookings/${slug}`;
                }
            });
        }else{
            window.location.href = `${webBaseUrl}/bookings/${slug}`;
        }
        if (
            clinicListData?.length === 1 &&
            searchParams.get('clinic_id') == null &&
            searchParams.get('isNotBypass') == null &&
            isAppointmentDataAvailable
        ) {
            setClinicId(clinicListData[0].clinic_id);
            setSelectedLocation(clinicListData[0]);
            dispatch({ type: CLEAR_TREATMENT_DETAILS });
            setStep(BOOKING_LINK_STEP.TREATMENT);
        }
    }, [clinicListData]);


    return (
        <>
        <Helmet>
            <meta name="X-Robots-Tag" content="noindex,nofollow" />
            <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <div className={classNames(classes.bookingLinkPage, 'bookingLinkPageRedesign')}>
            <div
                className={classNames(
                    classes.mainContent,
                    shallRenderMobileStickyFooter() &&
                        shallRenderNextStepButton() &&
                        classes.mainContentWithNextButton,
                    shallRenderStickyFooterTreatment() &&
                        classes.mainContentWithNextButtonAndTreatment
                )}
            >
                {/* {step === BOOKING_LINK_STEP.LOCATION && (
                    <SelectLocation
                        selectedLocation={selectedLocation}
                        setClinicId={setClinicId}
                        setFormatedDate={setFormatedDate}
                        setSelectedLocation={setSelectedLocation}
                        setSelectedTreatment={setSelectedTreatment}
                        setShowSelectedDate={setShowSelectedDate}
                        setShowSelectedTime={setShowSelectedTime}
                        setStep={setStep}
                    />
                )} */}
                {step === BOOKING_LINK_STEP.TREATMENT && (
                    <SelectTreatment
                        setStep={setStep}
                        cartData={selectedItems} // Pass the selected items as needed
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        selectedTreatments={selectedTreatments}
                        selectedTreatment={selectedTreatment}
                        setSelectedTreatments={setSelectedTreatments}
                        setSelectedTreatment={setSelectedTreatment}
                        setClinicId={setClinicId}
                        clinicId={clinicId}
                        onTreatmentChange={resetDataAfterTreatmentSelection}
                        selectedClinicSlug={selectedLocation}
                    />
                )}
                {step === BOOKING_LINK_STEP.DATE_AND_TIME && (
                    <SelectDateTime
                        step={step}
                        showSelectedDate={showSelectedDate}
                        setShowSelectedDate={setShowSelectedDate}
                        showSelectedTime={showSelectedTime}
                        setShowSelectedTime={setShowSelectedTime}
                        clinicId={clinicId}
                        setFormatedDate={setFormatedDate}
                        selectedTreatment={selectedTreatment}
                        setStep={setStep}
                        resetData={resetDataAfterDateOrTimeSelection}
                    />
                )}
                {step === BOOKING_LINK_STEP.TEAM_MEMBER && (
                    <SelectTeamMember
                        step={step}
                        setStep={setStep}
                        selectedTeamMember={selectedTeamMember}
                        setSelectedTeamMember={setSelectedTeamMember}
                        selectedTreatment={selectedTreatment}
                        setSelectedTreatment={setSelectedTreatment}
                        setSelectedTreatmentId={setSelectedTreatmentId}
                        selectedTreatmentId={selectedTreatmentId}
                    />
                )}
                {step === BOOKING_LINK_STEP.CLIENT_DETAILS && (
                    <EnterClientDetails
                        isSprintApiLoading={
                            getSprintBookingLinkDetailsQueryData.loading || !sprintBookingDetails
                        }
                        setYourDetails={setYourDetails}
                        yourDetails={yourDetails}
                        selectedLocation={selectedLocation}
                        selectedTeamMember={selectedTeamMember}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                        paymentOptionError={paymentOptionError}
                        handlePaymentOptionChange={handlePaymentOptionChange}
                        selectedPaymentOption={selectedPaymentOption}
                        totalPrice={getTotalPrice()}
                        totalDeposit={getTotalDeposit()}
                        setStep={setStep}
                        grandTotal={getTotalPriceAfterDiscount()}
                        bookingId={bookingId}
                        onClientDetailsChange={() => {
                            setShallCreateNewBooking(true);
                            setSelectedPaymentOption('');
                            dispatch({ type: CLEAR_SPRINT_BOOKING_LINK_DETAILS_DATA });
                        }}
                        payl8rData={payl8rData}
                        callPayl8rApi={callPayl8rApi}
                        selectedTreatment={selectedTreatment}
                        formatedDate={formatedDate}
                        selectedTimes={getTimeRange()}
                        discountValue={discountValue}
                        clinicId={clinicId}
                        handleRemoveDiscount={handleRemoveDiscount}
                        ClinicSlug={searchParams.get('clinicSlug')}
                    />
                )}

                {/* Desktop sticky footer */}
                <div className={classNames(classes.stickyFooter, classes.stickyFooterDesktop)}>
                    <div className={classes.stickyFooterMain}>
                        <CustomContainer removeTopPadding>
                            <PoweredByFaces />
                        </CustomContainer>
                    </div>
                    {shallDisplaySidebar() && <div className={classes.stickyFooterSideBlock}></div>}
                </div>

                {/* Mobile sticky footer */}
                {shallRenderMobileStickyFooter() && (
                    <div
                        className={classNames(
                            classes.stickyFooter,
                            classes.stickyFooterMobile,
                            shallRenderNextStepButton() && classes.stickyFooterWithButton,
                            shallRenderStickyFooterTreatment() &&
                                classes.stickyFooterWithTreatmentSection
                        )}
                    >
                        <div className={classes.stickyFooterMain}>
                            <CustomContainer removeTopPadding>
                                {shallRenderNextStepButton() && (
                                    <>
                                        {shallRenderStickyFooterTreatment() && (
                                            <FlexBetweenItem>
                                                <AppText font={APP_COMPONENT_SIZE.small}>
                                                    {selectedTreatment?.length} Treatment{selectedTreatment?.length > 1 ? 's' : ''} added
                                                </AppText>
                                                <AppText weight={600} dark font={APP_COMPONENT_SIZE.small}>
                                                    Total: {pounds.format(getTotalPrice())}
                                                </AppText>
                                            </FlexBetweenItem>
                                        )}
                                        <StepButton
                                            className={classes.stickyFooterButton}
                                            label="Continue"
                                            blue
                                            isLoading={isNextButtonLoading()}
                                            disabled={isNextStepDisabled()}
                                            onClick={() => {
                                                handleNextStep();
                                            }}
                                        />
                                    </>
                                )}
                                <PoweredByFaces />
                            </CustomContainer>
                        </div>
                        {shallDisplaySidebar() && (
                            <div className={classes.stickyFooterSideBlock}></div>
                        )}
                    </div>
                )}
            </div>
            {shallDisplaySidebar() && (
                <SidebarSummary
                    callPayl8rApi={() => {
                        callPayl8rApi();
                        setModalOpen(true);
                    }}
                    selectedLocation={selectedLocation}
                    step={step}
                    setStep={setStep}
                    selectedTreatment={selectedTreatment}
                    handleNextStep={handleNextStep}
                    isNextStepDisabled={isNextStepDisabled}
                    formatedDate={formatedDate}
                    selectedTimes={getTimeRange()}
                    selectedTeamMember={selectedTeamMember}
                    // isNextButtonLoading={isNextButtonLoading()}
                    totalPrice={getTotalPrice()}
                    clinicId={clinicId}
                    discountValue={discountValue}
                    grandTotal={getTotalPriceAfterDiscount()}
                    shallRenderNextStepButton={shallRenderNextStepButton()}
                    handleRemoveDiscount={handleRemoveDiscount}
                    selectedPaymentOption={selectedPaymentOption}
                    // handleRemoveDiscount={() => {
                    //     setDiscountValue(0)
                    //     dispatch({ type: CLEAR_DISCOUNT_CODE_CONST });
                    //     // initConfirmBookingRequest(selectedPaymentOption, UPDATE_DISC_TYPE.REMOVE);
                    //     // todo: handle remove discount api call
                    // }}
                    isEdit={clinicListData?.length > 1 && true}
                />
            )}
            <Payl8rPopup
                payl8rData={payl8rData}
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
            />
            <Toaster position="top-right" reverseOrder={false} />
        </div>
        </>
    );
}
export default BookingLink;
